export default "__VITE_ASSET__o1l$T9Hu__"